// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AC5OB","img":"Navbar_img__POx5y"};